/**
 * HeroPolaroids
 * Scattered polaroid photos in the hero background.
 *
 * Usage: just pass an array of imported images:
 *   <HeroPolaroids photos={[photo1, photo2, photo3]} />
 *
 * Photos cycle through predefined slot positions (left & right columns).
 * Add as many images as you like — they'll wrap around the slots.
 * Scales down on smaller screens to stay out of the way.
 */

// Predefined positions — alternates left / right, top → bottom.
// You can tweak these to taste.
const SLOTS = [
  { top: "4%",    left:  "1%",    rotate: "-7deg",  width: "168px", delay: "500ms"  },
  { top: "36%",   left:  "0.5%",  rotate: "9deg",   width: "152px", delay: "700ms"  },
  { top: "66%",   left:  "2%",    rotate: "-4deg",  width: "175px", delay: "900ms"  },
  { top: "8%",    right: "1%",    rotate: "8deg",   width: "158px", delay: "600ms"  },
  { top: "40%",   right: "0.5%",  rotate: "-11deg", width: "165px", delay: "800ms"  },
  { top: "68%",   right: "2%",    rotate: "6deg",   width: "170px", delay: "1000ms" },
  { top: "20%",   left:  "1.5%",  rotate: "12deg",  width: "145px", delay: "1100ms" },
  { top: "56%",   right: "1.5%",  rotate: "-8deg",  width: "160px", delay: "1200ms" },
];

const HeroPolaroids = ({ photos = [] }) => {
  if (!photos.length) return null;

  return (
    <div className="md-hero-polaroids" aria-hidden="true">
      {photos.map((src, i) => {
        const slot = SLOTS[i % SLOTS.length];
        return (
          <div
            key={i}
            className="md-hero-polaroid md-animate-fade-in"
            style={{
              top:              slot.top,
              left:             slot.left,
              right:            slot.right,
              bottom:           slot.bottom,
              "--base-width":   slot.width,
              transform:        `rotate(${slot.rotate})`,
              animationDelay:   slot.delay,
              animationFillMode: "forwards",
            }}
          >
            <div className="md-hero-polaroid__img">
              <img src={src} alt="" />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HeroPolaroids;
